export {default} from './AirbnbRedirectButton';



// WEBPACK FOOTER //
// ./src/containers/AirbnbRedirectVerificationProcedure/private/AirbnbRedirectButton/index.ts